import * as ActionTypes from './types';
import { actionCreator } from '../helpers/actionCreator';

export const registerChild = actionCreator(ActionTypes.REGISTER_CHILD);
export const registerChildSuccess = actionCreator(ActionTypes.REGISTER_CHILD_SUCCESS);
export const registerChildFailed = actionCreator(ActionTypes.REGISTER_CHILD_FAILED);
export const userIsUnauthorized = actionCreator(ActionTypes.USER_IS_UNAUTHORIZED);

export const logout = actionCreator(ActionTypes.LOGOUT);
